import { ISiTabConfig } from '../interfaces/si-tab-config.interface';

export class SiTabConfig implements ISiTabConfig {
    tabName: string;
    tabId: string;
    path: string;
    tabSequence: number;

    constructor(tabName: string,
        tabId: string,
        path: string,
        tabSequence: number) {
        this.setTabName(tabName);
        this.setTabId(tabId);
        this.setPath(path);
        this.setTabSequence(tabSequence);
    }

    setTabName(tabName: string): void {
        this.tabName = tabName;
    }
    getTabName(): string {
        return this.tabName;
    }

    setTabId(tabId: string): void {
        this.tabId = tabId;
    }
    getTabId(): string {
        return this.tabId;
    }

    setPath(path: string): void {
        this.path = path;
    }
    getPath(): string {
        return this.path;
    }
    setTabSequence(tabSequence: number): void {
        this.tabSequence = tabSequence;
    }
    getTabSequence(): number {
        return this.tabSequence;
    }
}
